var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-search",
    transform: "translate(-550 -561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(550 561)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762",
    transform: "translate(580 591)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1497",
    "data-name": "Rectangle 1497",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3.602 2.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762-2",
    "data-name": "Group 3762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M53.573,44.55l-8.71-8.708A6.092,6.092,0,0,0,37.9,34.686l-3.316-3.318A18.419,18.419,0,0,0,20.225,1.414,18.418,18.418,0,1,0,31.755,34.2l3.316,3.316a6.091,6.091,0,0,0,1.158,6.96l8.708,8.714a6.107,6.107,0,0,0,8.636-8.638ZM10.025,30.036a14.424,14.424,0,1,1,20.4,0A14.336,14.336,0,0,1,10.025,30.036ZM50.743,50.358a2.11,2.11,0,0,1-2.978,0l-8.708-8.712a2.105,2.105,0,0,1,2.978-2.976l8.708,8.71a2.117,2.117,0,0,1,0,2.978Z",
    transform: "translate(-1.801 -1.414)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M15.54,4.637A11.9,11.9,0,0,0,7.07,8.145,2,2,0,0,0,9.9,10.973a7.977,7.977,0,0,1,11.28,0,2,2,0,0,0,2.828-2.828A11.894,11.894,0,0,0,15.54,4.637Z",
    transform: "translate(2.883 1.809)",
    fill: "#1a1b43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptySearch);
export default __webpack_public_path__ + "static/media/icon-empty-search.92ad0e0d08b446b716ecd78b3add04ab.svg";
export { ForwardRef as ReactComponent };